import { render, staticRenderFns } from "./TemplateImages.vue?vue&type=template&id=70f8c6c4"
import script from "./TemplateImages.vue?vue&type=script&lang=js"
export * from "./TemplateImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports